export const mapAgeToColor = (age: number) => {
  if (age <= 1) return 'success';

  if (age === 2) return 'yellow';

  if (age === 3) return 'warning';

  if (age <= 10) return 'error';

  return 'purple';
};
